<template>
	<div class="invoices-subview">
		<div id="invoicesSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {ContextKey, getIntValue, injectContext} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const restApi = computed<string>(() => {
	let ep = "api/invoices/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});
</script>

<style>
.invoices-subview {
	padding-top: 8px;
}
</style>